import { message } from 'antd';
// import JSZip from 'jszip';
import saveAs from 'file-saver';

function getBase64Image(img, width, height) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = width || img.width;
  canvas.height = height || img.height;
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return convertBase64UrlToBlob(canvas.toDataURL('image/jpeg', 1));
}

function convertBase64UrlToBlob(urlData) {
  const arr = urlData.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

// 打包下载
const ZipDownload = (data, w, h) => {
  const picList = [];
  data.map((item, index) => {
    if (
      // !item.kname.match(/second_car_report/) &&
      // !item.kname.match(/video/) &&
      item.url
    ) {
      const picArr = item.url.split('||');
      const arr = [];
      for (let i = 0; i < picArr.length; i++) {
        arr.push({
          name: i,
          // kname: item.kname,
          url: picArr[i],
        });
      }
      picList.push({
        title: item.name,
        arr,
      });
    }
  });
  console.log(picList);
  const picArr = [];
  let laseTime = null;
  const hasMsg = message.loading('');
  picList.forEach((arrItem, i) => {
    picArr.push({ title: arrItem.title, arr: [] });
    if (arrItem.arr.length > 0) {
      arrItem.arr.forEach((item) => {
        // if (!item.kname.match(/video/) && item.url) {
        if (item.url) {
          const img = new Image();
          img.crossOrigin = '';
          img.width = w || 500;
          img.height = h || 260;
          img.onload = function () {
            picArr[i].arr.push({
              name: item.name,
              url: getBase64Image(img),
            });
            if (laseTime) {
              clearTimeout(laseTime);
            }
            laseTime = setTimeout(() => {
              hasMsg();
              // const ZIP = new JSZip();
              picArr.forEach((arrItem) => {
                // console.log(arrItem, 'arrItem')
                /* 逐个文件夹 */
                // const file = ZIP.folder(arrItem.title)
                // arrItem.arr.forEach(item => {
                //   if (item.url) {
                //     file.file(`${item.name}.png`, item.url, { base64: true })
                //   }
                // })
                /* 直接写入 */
                arrItem.arr.forEach((item) => {
                  if (item.url) {
                    ZIP.file(`${arrItem.title}.png`, item.url, { base64: true });
                  }
                });
              });
              ZIP.generateAsync({ type: 'blob' }).then((content) => {
                saveAs(content, '文件.zip');
              });
            }, 1000);
          };
          // img.src = PIC_PREFIX + item.url
          img.src = item.url;
        } else {
          return false;
        }
      });
    }
  });
};

export default ZipDownload;
